import axios from "axios"

export default {
    state: {
        blogs: [],
        blog: null
    },
    getters: {
        blogs(state) {
            return state.blogs;
        },
        blog(state) {
            return state.blog;
        }
    },
    mutations: {
        setBlogs(state, blogs) {
            state.blogs = blogs;
        },

        setBlog(state, blog) {
            state.blog = blog;
        }
    },
    actions: {
        async getBlogs({ commit }) {
            let res = await axios.get(`/posts`);
            let blogs = res.data.data;
            commit('setBlogs', blogs)
        },

        async getBlogDetail({ commit }, id) {
            let res = await axios.get(`/posts/${id}`);
            let blog = res.data.data;
            commit('setBlog', blog)
        }
    }
}